<script>
import CatalogFilterBlock from "@js/components/Sections/Catalog/Components/CatalogFilterBlock.vue";
import {useCatalogStore} from "@js/store/CatalogStore.js";
import VueSlider from "vue-3-slider-component";
import SpinnerIndicator from "@js/components/Sections/Statuses/SpinnerIndicator.vue";
import CatalogFilterBlockLoading from "@js/components/Sections/Catalog/Components/CatalogFilterBlockLoading.vue";
import FormattedNumberInput from "@js/components/Input/FormattedNumberInput.vue";

export default {
    name: "CatalogFilter",
    components: {FormattedNumberInput, CatalogFilterBlockLoading, SpinnerIndicator, CatalogFilterBlock, VueSlider},
    data() {
        return {
            reset_hovered: false,
            getCatalogTimeout: null,
        }
    },
    mounted() {
        this.catalogStore.getFilterBasicCategories()
        this.catalogStore.getFilterLimits()
    },
    setup() {
        const catalogStore = useCatalogStore()

        return {catalogStore}
    }
}
</script>

<template>
    <div class="w-full">
        <div class="relative flex items-center justify-between yellow-border pb-2 border-b border-gray-200"
             :class="{'yellow-border-rtl':reset_hovered}">
            <div class="text-xl font-medium">
                Фильтр
            </div>
            <div @click="catalogStore.resetFilter"
                 @mouseenter="reset_hovered = true"
                 @mouseleave="reset_hovered = false"
                 class="font-sm font-semibold flex items-center fill-black hover:text-indigo-600 hover:fill-indigo-600 cursor-pointer transition">
                <svg class="w-5 h-5 me-1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M362.667 256a106.667 106.667 0 0 1 106.666 106.667c0 58.91-47.756 106.666-106.666 106.666S256 421.577 256 362.667 303.756 256 362.667 256Zm0 21.333c-47.129 0-85.334 38.205-85.334 85.334 0 47.128 38.205 85.333 85.334 85.333C409.795 448 448 409.795 448 362.667c0-47.129-38.205-85.334-85.333-85.334Zm36.543 33.706 15.085 15.085-36.544 36.543 36.544 36.543-15.085 15.085-36.543-36.544-36.543 36.544-15.085-15.085 36.543-36.543-36.543-36.543 15.085-15.085 36.543 36.543 36.543-36.543ZM384 85.333l-149.333 182v122H192v-122l-149.333-182H384Z"
                        fill-rule="evenodd"/>
                </svg>
                Сбросить
            </div>
        </div>
        <!--Цена-->
        <CatalogFilterBlock title="Цена">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.price"
                           :min="catalogStore.filter_data.limits.price[0]"
                           :max="catalogStore.filter_data.limits.price[1]"
                           :interval="1"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput placeholder=" " name="cf_price_from" id="cf_price_from"
                                              :min="catalogStore.filter_data.limits.price[0]"
                                              :max="catalogStore.filter_data.limits.price[1]"
                                              v-model="catalogStore.filter.price[0]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_price_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Цена от
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_price_to" id="cf_price_to" placeholder=" "
                                              :min="catalogStore.filter_data.limits.price[0]"
                                              :max="catalogStore.filter_data.limits.price[1]"
                                              v-model="catalogStore.filter.price[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_price_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Цена до
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Цена-->
        <!--Категория-->
        <CatalogFilterBlock title="Вид строительства">
            <div v-if="catalogStore.filter_data.base_categories"
                 v-for="(item, key) in catalogStore.filter_data.base_categories" :key="key" class="py-2">
                <div class="flex items-center">
                    <input :id="'base-category-' + key" type="checkbox"
                           v-model="catalogStore.filter.base_categories"
                           @change="catalogStore.removeNestedCheckBoxes($event,'base_categories')"
                           :value="item.slug"
                           class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm cursor-pointer">
                    <label :for="'base-category-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span>
                            {{ item.name }}
                        </span>
                        <span v-if="item.products_count" class="text-sm font-medium text-gray-900">
                            ({{ item.products_count }})
                        </span>
                    </label>
                </div>
            </div>
            <div v-else>
                <CatalogFilterBlockLoading v-if="catalogStore.loadings.base_categories_loaded"/>
                <div v-else>
                    Пусто
                </div>
            </div>
        </CatalogFilterBlock>
        <CatalogFilterBlock title="Тип продукции" v-if="catalogStore.filter_data.categories.length > 0">
            <div v-for="(item, key) in catalogStore.filter_data.categories" :key="key" class="py-2">
                <div class="flex items-center">
                    <input :id="'category-' + key" type="checkbox"
                           v-model="catalogStore.filter.categories"
                           @change="catalogStore.removeNestedCheckBoxes($event,'categories')"
                           :value="item.slug"
                           class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm cursor-pointer">
                    <label :for="'category-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span>
                            {{ item.name }}
                        </span>
                        <span v-if="item.products_count" class="text-sm font-medium text-gray-900">
                            ({{ item.products_count }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <CatalogFilterBlock title="Категории продукции" v-if="catalogStore.filter_data.sub_categories.length > 0">
            <div v-for="(item, key) in catalogStore.filter_data.sub_categories" :key="key" class="py-2">
                <div class="flex items-center">
                    <input :id="'sub-category-' + key" type="checkbox"
                           v-model="catalogStore.filter.sub_categories"
                           :value="item.slug"
                           class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm cursor-pointer">
                    <label :for="'sub-category-' + key"
                           class="flex items-center justify-between w-full ms-2 text-sm font-medium text-gray-900 cursor-pointer">
                        <span>
                            {{ item.name }}
                        </span>
                        <span v-if="item.products_count" class="text-sm font-medium text-gray-900">
                            ({{ item.products_count }})
                        </span>
                    </label>
                </div>
            </div>
        </CatalogFilterBlock>
        <!--Категория-->
        <!--Длина-->
        <CatalogFilterBlock title="Длина" :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.length"
                           :min="catalogStore.filter_data.limits.length[0]"
                           :max="catalogStore.filter_data.limits.length[1]"
                           :interval="1"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_length_from" id="cf_length_from" placeholder=" "
                                              v-model="catalogStore.filter.length[0]"
                                              :min="catalogStore.filter_data.limits.length[0]"
                                              :max="catalogStore.filter_data.limits.length[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_length_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Длина от (мм)
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_length_to" id="cf_length_to" placeholder=" "
                                              v-model="catalogStore.filter.length[1]"
                                              :min="catalogStore.filter_data.limits.length[0]"
                                              :max="catalogStore.filter_data.limits.length[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_length_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Длина до (мм)
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Длина-->
        <!--Ширина-->
        <CatalogFilterBlock title="Ширина" :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.width"
                           :min="catalogStore.filter_data.limits.width[0]"
                           :max="catalogStore.filter_data.limits.width[1]"
                           :interval="1"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_width_from" id="cf_width_from" placeholder=" "
                                              v-model="catalogStore.filter.width[0]"
                                              :min="catalogStore.filter_data.limits.width[0]"
                                              :max="catalogStore.filter_data.limits.width[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_width_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Ширина от (мм)
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_width_to" id="cf_width_to" placeholder=" "
                                              v-model="catalogStore.filter.width[1]"
                                              :min="catalogStore.filter_data.limits.width[0]"
                                              :max="catalogStore.filter_data.limits.width[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_width_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Ширина до (мм)
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Ширина-->
        <!--Высота-->
        <CatalogFilterBlock title="Высота" :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.height"
                           :min="catalogStore.filter_data.limits.height[0]"
                           :max="catalogStore.filter_data.limits.height[1]"
                           :interval="1"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_height_from" id="cf_height_from" placeholder=" "
                                              v-model="catalogStore.filter.height[0]"
                                              :min="catalogStore.filter_data.limits.height[0]"
                                              :max="catalogStore.filter_data.limits.height[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                        />
                        <label for="cf_height_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Высота от (мм)
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_height_to" id="cf_height_to" placeholder=" "
                                              v-model="catalogStore.filter.height[1]"
                                              :min="catalogStore.filter_data.limits.height[0]"
                                              :max="catalogStore.filter_data.limits.height[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_height_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Высота до (мм)
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Высота-->
        <!--Вес-->
        <CatalogFilterBlock title="Вес" :default_open="false">
            <div v-if="catalogStore.loadings.filter_limits_loaded">
                <VueSlider v-model="catalogStore.filter.weight"
                           :min="catalogStore.filter_data.limits.weight[0]"
                           :max="catalogStore.filter_data.limits.weight[1]"
                           :interval="0.1"
                           tooltip="none"/>
                <div class="grid grid-cols-2 gap-5 mt-4">
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_weight_from" id="cf_weight_from" placeholder=" "
                                              v-model="catalogStore.filter.weight[0]"
                                              :min="catalogStore.filter_data.limits.weight[0]"
                                              :max="catalogStore.filter_data.limits.weight[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_weight_from"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Вес от (тонн)
                        </label>
                    </div>
                    <div class="relative z-0 w-full group">
                        <FormattedNumberInput name="cf_weight_to" id="cf_weight_to" placeholder=" "
                                              v-model="catalogStore.filter.weight[1]"
                                              :min="catalogStore.filter_data.limits.weight[0]"
                                              :max="catalogStore.filter_data.limits.weight[1]"
                                              class="block pt-2 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b border-gray-500 appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"/>
                        <label for="cf_weight_to"
                               class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                            Вес до (тонн)
                        </label>
                    </div>
                </div>
            </div>
            <CatalogFilterBlockLoading v-else/>
        </CatalogFilterBlock>
        <!--Вес-->
    </div>
</template>

<style scoped lang="scss">
.yellow-border:before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100px;
    height: 2px;
    background: var(--main-color);
    transition: left .3s;
}

.yellow-border-rtl:before {
    left: calc(100% - 100px);
}
</style>
